<template>
  <el-date-picker
    v-if="isImport(item)"
    size="mini"
    v-model.lazy="item.lfd"
    type="date"
    format="MM/dd/yy"
    :value-format="'yyyy-MM-dd'"
    @change="$emit('columnEvent', 'autoSave', item, 'rail_lfd', $event)"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: "order-status-lfd",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
